'use client';

import { useState } from 'react';
import { useAuthStore } from '../auth/useAuthStore';

/**
 * Current-user profile adapter. The backend exposes no self-profile edit
 * endpoint yet (customer profiles live in CRM), so updateProfile/changePassword
 * are safe no-ops that resolve — the profile cards render read-only user data.
 */
export const useUserProfile = () => {
  const user = useAuthStore((s) => s.user);
  const getUserInitials = useAuthStore((s) => s.getUserInitials);
  const getDisplayName = useAuthStore((s) => s.getDisplayName);
  const [saving, setSaving] = useState(false);
  const [changingPassword, setChangingPassword] = useState(false);

  const profileData = {
    name: user?.name ?? '',
    email: user?.email ?? '',
    phone: '',
  };

  const updateProfile = async (_data: Partial<typeof profileData>) => {
    setSaving(true);
    try {
      // TODO: wire to a self-profile endpoint when the backend adds one.
      return true;
    } finally {
      setSaving(false);
    }
  };

  const changePassword = async (_current: string, _next: string) => {
    setChangingPassword(true);
    try {
      // TODO: wire to IdentityService password change when available.
      return true;
    } finally {
      setChangingPassword(false);
    }
  };

  return {
    user,
    loading: false,
    isAuthenticated: user !== null,
    profileData,
    updateProfile,
    saving,
    changePassword,
    changingPassword,
    userInitials: getUserInitials(),
    displayName: getDisplayName(),
  };
};
